export default __webpack_public_path__ + "static/media/top_flowers.d4706aa5.png";